import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';

/** Clear workspace state and refetch all active TanStack Query caches after org switch. */
export async function refreshAfterOrgSwitch(queryClient) {
  useFestivalWorkspaceStore.getState().clearFestivalWorkspace();
  await queryClient.invalidateQueries();
}
